import { Resource } from 'service/Resource'

import { ShipmentInterface } from '../domain/ShipmentInterface'

export interface ShipmentEndpoint extends Resource<ShipmentInterface, ShipmentInterface> {}

export const createShipmentEndpoint = (http) => {
  return new Resource<ShipmentInterface, ShipmentInterface>('shipments', http)
}
